/**
 * Makes a slideshow slide clickable when its `_slide` block has the
 * atomberg_link setting (see blocks/_slide.liquid, ATOMBERG CUSTOMIZATION).
 * Delegated document click, not a per-slide listener — slides are
 * re-rendered by Horizon's own JS on drag/loop, so binding directly to
 * a slide element would go stale.
 *
 * Only navigates when the slide is already the active one
 * (aria-hidden="false") — clicking a peeking/inactive slide is Horizon's
 * own "bring this slide into view" gesture (slideshow-slide.liquid's
 * on:click="/select/{index}"); intercepting that click would fight it.
 * Clicks on a real link/button inside the slide (e.g. its own CTA button)
 * are left alone.
 */
(function () {
  if (/** @type {any} */ (window)._atombergSlideLinkInit) return;
  /** @type {any} */ (window)._atombergSlideLinkInit = true;

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var slide = e.target.closest('slideshow-slide');
    if (!slide || slide.getAttribute('aria-hidden') !== 'false') return;
    if (e.target.closest('a, button')) return;

    var marker = slide.querySelector('[data-atomberg-slide-link-url]');
    if (!marker) return;
    var url = marker.getAttribute('data-atomberg-slide-link-url');
    if (!url) return;

    if (marker.hasAttribute('data-atomberg-slide-link-new-tab')) {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.assign(url);
    }
  });
})();
